
const digest = 'dd61dc5fda43b46f661e8b12e464ed83679d5bc0a53b318c807cac2d85806368';
const classes = {"wrapper":"_wrapper_exlx5_1","content":"_content_exlx5_19","title":"_title_exlx5_23"};
const css = `._wrapper_exlx5_1 {
  background: #ffffff;
  border-radius: 15px;
  padding: 14px 20px;
  box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  min-height: 76px;
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
._wrapper_exlx5_1:hover {
  transform: scale(1.02);
}
._wrapper_exlx5_1 ._content_exlx5_19 {
  display: flex;
  flex-direction: column;
}
._wrapper_exlx5_1 ._content_exlx5_19 ._title_exlx5_23 {
  font-size: 16px;
  font-weight: 400;
}
._wrapper_exlx5_1 img {
  height: 35px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  